import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

export const PAGE_ACTIONS_SLOT_ID = 'page-actions-slot';

export function PageActions({ children }: { children: ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setSlot(document.getElementById(PAGE_ACTIONS_SLOT_ID));
  }, []);

  if (!slot) return null;
  return createPortal(children, slot);
}
